import {TextField} from "@material-ui/core";
import {Button, Form} from "react-bootstrap";
import Message from "../message";
import {useEffect, useState} from "react";

function Mca() {
    const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

    const [mca_col_name, setMca_col_name] = useState("");
    const [mca, setMca] = useState("");
    const [status_mca, setStatus_mca] = useState("");
    const [status_true_captcha_creds, setStatus_true_captcha_creds] =
        useState("fetching...");

    useEffect(async () => {
        const creds_remaining = await fetch(
            apiServer + "api/helper/true_captcha_account"
        );
        setStatus_true_captcha_creds(await creds_remaining.json());
    }, []);

    const sumbit_mca = async () => {
        setStatus_mca("");

        if (mca.length <= 0) {
            setStatus_mca("Upload some files!");
        } else if (mca_col_name === "") {
            setStatus_mca("Fill column name!");
        } else {
            const gst_formData = new FormData();
            gst_formData.set("file", mca);

            const requestOptions = {
                method: "POST",
                body: gst_formData,
            };

            var gst_status_id = "";
            try {
                const gst_response = await fetch(
                    apiServer + `api/mca/upload_file?col_name=${mca_col_name}`,
                    requestOptions
                );
                gst_status_id = await gst_response.json();
                console.log(gst_status_id);

                const gst_status = gst_status_id.detail
                    ? gst_status_id.detail
                    : gst_status_id;

                setStatus_mca(gst_status);
            } catch (e) {
                console.log(e);
            }
        }
    };

    return (
        <div style={{marginTop: "2px"}}>
            <p>
                Credits remaining: <strong>{status_true_captcha_creds}</strong>
            </p>
            <TextField
                style={{marginBottom: "15px", width: "100%", marginTop: "5px"}}
                value={mca_col_name}
                onChange={(e) => setMca_col_name(e.target.value)}
                id="outlined-basic"
                label="Column name"
                variant="filled"
            />
            <Form.Control type="file" onChange={(e) => setMca(e.target.files[0])}/>
            <Button
                variant="primary"
                style={{marginTop: "20px", width: "100%"}}
                onClick={() => sumbit_mca()}
            >
                Submit
            </Button>
            {Message(status_mca, setStatus_mca)}
        </div>
    );
}

export default Mca;
